/* eslint-disable jsx-a11y/alt-text */
import { getAccessTokenSilently } from "utils/functions";
import { TableContainer } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Pagination from '@material-ui/lab/Pagination';
import { CircularProgress } from '@mui/material';
import MemberService from 'Lib/API/Member';
import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { useHistory } from "react-router-dom";
import './index.scss';
import { Fonts, FontFamilies, FontColors } from "theme/fontConfig";
const TableCellHead = withStyles((theme) => ({
  root: {
    height: '39px',
    padding: '0px 20px',
    borderBottom: 'none',
    fontFamily: FontFamilies.General,
  },
}))(TableCell);

const TableCellBody = withStyles((theme) => ({
  root: {
    height: '65px',
    padding: '0px 20px',
    fontFamily: Fonts.GeneralBodyFont.fontFamily,
    fontSize: Fonts.GeneralBodyFont.fontSize,
    color: FontColors.Slate4D5565
  },
}))(TableCell);

const ClassList = () => {
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width:600px)");

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [count, setCount] = useState();

  const [page, setPage] = useState(0);

  const enableLoading = (value) => {
    setLoading(value);
  };
  async function getClassesList() {
    enableLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const payload = {
      };
      const result = await MemberService.getClassParticipantsByAccounts({
        token,
        payload,
        page: page + 1,
        limit: 30,
      });
      setList(result?.payload?.data);
      setCount(result?.payload?.pagination?.count);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong!');
    } finally {
      enableLoading(false);
    }
  }
  React.useEffect(() => {
    getClassesList();
  }, [page]);






  if (loading) return (
    <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
      <CircularProgress />
    </div>
  );

  if (!list?.length) return (
    <div style={{ textAlign: "center", padding: "60px 0", color: FontColors.Slate64748B, fontFamily: FontFamilies.General }}>
      No Classes Found
    </div>
  );

  return (
    <div className="w-100 school_class_list mt-4">
      <div className="family-table-container">
        <div className="current-class-table-container">
          {isMobile ? (
            <div style={{ padding: "12px 16px", display: "flex", flexDirection: "column", gap: 12 }}>
              {list.map((row, i) => (
                <div key={i} style={{
                  background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0",
                  padding: "12px 16px",
                }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                    <div style={{ ...Fonts.GeneralSubHeaderFont, color: FontColors.Slate0F172A }}>
                      {`${row?.firstName || ""} ${row?.lastName || ""}`.trim()}
                    </div>
                    <div style={{
                      flexShrink: 0,
                      ...Fonts.GeneralSmallLabelFont, 
                      color: FontColors.Blue2555EF, background: "#EEF2FF", borderRadius: 20,
                      padding: "2px 10px",
                    }}>
                      {row?.registrationStatus !== "not-approve" ? row?.registrationStatus : "-"}
                    </div>
                  </div>
                  <div style={{ fontFamily: Fonts.GeneralSmallBodyFont.fontFamily, fontSize: Fonts.GeneralSmallBodyFont.fontSize, color: FontColors.Slate64748B, marginTop: 2 }}>
                    {row?.class?.class_name}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ padding: "17px" }}>
              <TableContainer className="scroll-table">
                <Table aria-label="collapsible table">
                  <TableHead className="charges-table sticky-table-header">
                    <TableRow>
                      <TableCellHead className="class__header__cell className_head"><div>STUDENT NAME</div></TableCellHead>
                      <TableCellHead align="left" className="class__header__cell className_head"><div>CLASS NAME</div></TableCellHead>
                      <TableCellHead align="left" className="class__header__cell total__cost"><div>STATUS</div></TableCellHead>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ backgroundColor: "white" }}>
                    {list.map((row, i) => (
                      <React.Fragment key={i}>
                        <TableRow sx={{ "& > *": { borderBottom: "unset" } }} className="class_tableRow">
                          <TableCellBody className="main-width-class class-list-table-cell" component="th" scope="row">
                            <div className="school-table-className">
                              {`${row?.firstName || ""} ${row?.lastName || ""}`.trim()}
                            </div>
                          </TableCellBody>
                          <TableCellBody className="main-width-class class-list-table-cell" align="left">
                            <div className="school-table-className">{row?.class?.class_name}</div>
                          </TableCellBody>
                          <TableCellBody className="main-width-class class-list-table-cell" align="left">
                            <div className="school-table-year">
                              {row?.registrationStatus !== "not-approve" ? row?.registrationStatus : "-"}
                            </div>
                          </TableCellBody>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
          <div className="pagination-custom">
            <Pagination
              count={Math.ceil(count / 30)}
              color="primary"
              variant="outlined"
              page={page + 1}
              onChange={(event, value) => setPage(value - 1)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassList;
